import { pageWindow } from "../referralFormat";
import { referralStaffPagerActiveClass, referralStaffPagerIdleClass } from "../referralSurface";

type Props = {
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
};

export default function StaffReferralPager({ page, pageCount, onPage }: Props) {
  if (pageCount <= 1) {
    return null;
  }
  return (
    <div className="flex items-center">
      <button type="button" className={referralStaffPagerIdleClass} disabled={page <= 1} onClick={() => onPage(1)}>← First</button>
      {pageWindow(page, pageCount).map((item, index) => item === "…" ? (
        <span key={`gap-${index}`} className={referralStaffPagerIdleClass}>…</span>
      ) : (
        <button key={item} type="button" className={item === page ? referralStaffPagerActiveClass : referralStaffPagerIdleClass} onClick={() => onPage(item)}>{item}</button>
      ))}
      <button type="button" className={referralStaffPagerIdleClass} disabled={page >= pageCount} onClick={() => onPage(pageCount)}>Last →</button>
    </div>
  );
}
